'use strict';

module.exports = {
  IN: 'IN',
};
